import { ReactNode } from 'react';
import {
  AsyncFlagResult,
  useFeatureFlagUserVariation,
} from '../../hooks/useFeatureFlagUserVariation';
import { Entity } from '@backstage/catalog-model';
import { useFeatureFlagEntityVariation } from '../../hooks/useFeatureFlagEntityVariation';
import { FeatureFlag } from '../../featureFlags';

export type RequireFlagProps = {
  flag: FeatureFlag;
  errorPage?: ReactNode;
  children: ReactNode;
  invert?: boolean;
  entity?: Entity;
};

export function RequireFlag(props: RequireFlagProps): JSX.Element | null {
  const { children, flag, invert, entity, errorPage } = props;

  let flagResult: Pick<AsyncFlagResult, 'enabled'> = { enabled: false };
  if (entity) {
    flagResult = useFeatureFlagEntityVariation(flag, entity);
  } else {
    flagResult = useFeatureFlagUserVariation(flag);
  }

  if (flagResult.enabled !== Boolean(invert)) {
    return <>{children}</>;
  }

  if (errorPage) {
    return <>{errorPage}</>;
  }
  return null;
}
